import {Col, Row} from '@jetbrains/ring-ui/components/grid/grid'
import * as React from 'react'

import type {BuildTypeId} from '../../../../../types'
import BuildTypeBranch from '../../../../common/BranchLabel/BuildTypeBranchLabel.container'
import DifferenceMark from '../../DifferenceMark/DifferenceMark'

import styles from './RevisionRow.css'

type Props = {
  buildTypeId: BuildTypeId | null | undefined
  branch1: string | null | undefined
  hash1: string | null | undefined
  vcsRootName1: string | null | undefined
  branch2: string | null | undefined
  hash2: string | null | undefined
  vcsRootName2: string | null | undefined
  changed?: boolean | null | undefined
}

const renderCol = (
  buildTypeId: BuildTypeId | null | undefined,
  branch: string | null | undefined,
  hash: string | null | undefined,
  vcsRootName: string | null | undefined,
  changed: boolean | null | undefined,
) => (
  <Col xs={6}>
    <div className={styles.root}>{vcsRootName}</div>
    <div className={styles.canChange}>
      {buildTypeId ? (
        <BuildTypeBranch buildTypeId={buildTypeId} name={branch} className={styles.branch} />
      ) : null}
      {hash}
      {changed === true && hash != null && <DifferenceMark />}
    </div>
  </Col>
)

function RevisionRow({
  buildTypeId,
  branch1,
  hash1,
  vcsRootName1,
  branch2,
  hash2,
  vcsRootName2,
  changed,
}: Props) {
  return (
    <Row className={styles.row}>
      {renderCol(buildTypeId, branch1, hash1, vcsRootName1, changed)}
      {renderCol(buildTypeId, branch2, hash2, vcsRootName2, changed)}
    </Row>
  )
}

export default RevisionRow
